// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   FormControl,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Grid,
//   Paper,
//   Checkbox,
//   FormControlLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   RadioGroup,
//   Radio,
//   FormLabel,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import DownloadIcon from '@mui/icons-material/Download';

// const OutReach = () => {

//   const [date, setDate] = useState('');
//   const [serviceType, setServiceType] = useState('oldAgeHome');
//   const [loading, setLoading] = useState(false);

//   const [openPasswordModal, setOpenPasswordModal] = useState(false);
//   const [password, setPassword] = useState('');
//   const [downloadFormat, setDownloadFormat] = useState('excel');
//   const [saveStatus, setSaveStatus] = useState({ open: false, message: '', severity: 'success' });

//   const [demographic, setDemographic] = useState({
//     name: '',
//     age: '',
//     gender: '',
//     address: '',
//     education: '',
//     maritalStatus: '',
//     area: '',
//     socioEconomicStatus: '',
//     systemicIllness: '',
//     associatedProblems: [],
//     underMedication: false,
//     habits: { type: '', frequency: '' },
//     selfReport: {
//       hearingDifficulties: '',
//       speechPerception: '',
//       tinnitus: '',
//       vertigo: '',
//       noiseExposure: '',
//       earPain: '',
//       earDischarge: ''
//     },
//     hearingAidUsed: false,
//     hearingAidEar: '',
//     hearingAidDuration: '',
//     hearingAidPattern: '',
//     hearingAidHours: ''
//   });
//   const [questionnaire, setQuestionnaire] = useState({
//     scapA: '',
//     mmse: '',
//     moca: {
//       visospatial: '',
//       naming: '',
//       memory: '',
//       attention: '',
//       language: '',
//       abstraction: '',
//       delayedRecall: '',
//       orientation: '',
//       total: ''
//     },
//     mocaInterpretation: ''
//   });
//   const [otoscopy, setOtoscopy] = useState({
//     ear: 'right',
//     right: { result: '', notes: '' },
//     left: { result: '', notes: '' }
//   });   
//   const [tympanometry, setTympanometry] = useState({
//     ear: 'right',
//     right: '',
//     left: ''
//   });
//   const [hearingTest, setHearingTest] = useState({
//     ear: 'right',
//     mode: 'Ac',
//     thresholds: Array(10).fill('')
//   });
//   const [diagnosis, setDiagnosis] = useState({
//     right: '',
//     left: '',
//     medical: ''
//   });
//   const [recommendations, setRecommendations] = useState({
//     audiological: false,
//     psychological: false,
//     medical: false,
//     HAT: false,
//     SpeechEvaluation: false
//   });

//   const [hearingAid, setHearingAid] = useState({
//     ear: 'Right',
//     condition: 'Unaided',
//     stimuli: 'Questions',
//     questions: '',
//     words: ''
//   });
//   const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];
//   const associatedProblems = [
//     'Tinnitus',
//     'Ear pain',
//     'Ear discharge',
//     'Vertigo',
//     'Exposure to noise',
//     'None'
//   ];
//   const systemicIllnesses = [
//     'Diabetes',
//     'Hypertension',
//     'Cardiovascular disease',
//     'Ischemic heart disease',
//     'Vascular dementia',
//     'Multiple sclerosis',
//     'Stroke',
//     'Chronic Kidney disease',
//     'None'
//   ];
//   const handleThresholdChange = (index, value) => {
//     const newThresholds = [...hearingTest.thresholds];
//     newThresholds[index] = value;
//     setHearingTest({ ...hearingTest, thresholds: newThresholds });
//   };
//   const handleAssociatedProblemsChange = (problem) => {
//     const currentProblems = [...demographic.associatedProblems];
//     if (currentProblems.includes(problem)) {
//       setDemographic({
//         ...demographic,
//         associatedProblems: currentProblems.filter(p => p !== problem)
//       });
//     } else {
//       setDemographic({
//         ...demographic,
//         associatedProblems: [...currentProblems, problem]
//       });
//     }
//   };
//   const handleMocaChange = (field, value) => {
//     setQuestionnaire({
//       ...questionnaire,
//       moca: {
//         ...questionnaire.moca,
//         [field]: value
//       }
//     });
//   };
//   const handleHabitTypeChange = (value) => {
//     setDemographic({
//       ...demographic,
//       habits: {
//         ...demographic.habits,
//         type: value
//       }
//     });
//   };
//   const handleHabitFrequencyChange = (e) => {
//     setDemographic({
//       ...demographic,
//       habits: {
//         ...demographic.habits,
//         frequency: e.target.value
//       }
//     });
//   };
//   const handleSelfReportChange = (field, value) => {
//     setDemographic({
//       ...demographic,
//       selfReport: {
//         ...demographic.selfReport,
//         [field]: value
//       }
//     });
//   };
//   const handleDownloadClick = () => {
//     setOpenPasswordModal(true);
//   };
//   const handleDownloadConfirm = async () => {
//     const correctKey = "Varun@6361";

//     // Validate key entered in modal
//     if (password !== correctKey) {
//       alert("Incorrect key! Download canceled.");
//       setPassword('');
//       setOpenPasswordModal(false);
//       return;
//     }

//     setOpenPasswordModal(false);
//     setLoading(true);
//     setSaveStatus({
//       message: `Requesting Outreach Evaluation ${downloadFormat}...`,
//       severity: "info",
//     });

//     try {
//       const resp = await fetch(
//         "http://localhost:5000/api/reports/download-form",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             table: "outreach_evaluations",
//             formName: "Outreach Evaluation",
//             format: downloadFormat,
//             key: password   // 🔥 send KEY instead of password
//           }),
//         }
//       );

//       if (!resp.ok) {
//         const body = await resp.json().catch(() => ({}));
//         setSaveStatus({
//           message: `Failed: ${body.message || resp.statusText}`,
//           severity: "error",
//         });
//         return;
//       }

//       const blob = await resp.blob();
//       const disposition = resp.headers.get("content-disposition") || "";

//       let filename = `Outreach_Evaluation_${Date.now()}.${downloadFormat === "excel" ? "xlsx" : "pdf"
//         }`;

//       const match = /filename="?([^"]+)"?/.exec(disposition);
//       if (match && match[1]) filename = match[1];

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);

//       setSaveStatus({
//         message: `Download started: ${filename}`,
//         severity: "success",
//       });

//     } catch (err) {
//       console.error("Download error:", err);
//       setSaveStatus({
//         message: `Error downloading file: ${err.message}`,
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//       setPassword('');
//     }
//   };
//   const handlePasswordModalClose = () => {
//     setOpenPasswordModal(false);
//     setPassword('');
//   };
//   const handleOtoscopyResultChange = (ear, field, value) => {
//     setOtoscopy({
//       ...otoscopy,
//       [ear]: {
//         ...otoscopy[ear],
//         [field]: value
//       }
//     });
//   };
//   const handleSubmit = async () => {
//     try {
//       const formData = {
//         dateOfAssessment: date,
//         serviceType,
//         demographic,
//         questionnaire,
//         otoscopy,
//         tympanometry,
//         hearingTest,
//         diagnosis,
//         recommendations,
//         hearingAid: recommendations.HAT ? hearingAid : null
//       };

//       console.log('Submitting data:', formData); // Debug log

//       const response = await fetch('http://localhost:5000/api/outreach', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         const result = await response.json();
//         alert('Outreach evaluation saved successfully!');
//         resetForm();
//       } else {
//         const errorData = await response.json();
//         alert(`Failed to save: ${errorData.error}`);
//       }
//     } catch (error) {
//       console.error('Error submitting form:', error);
//       alert('Error saving outreach evaluation');
//     }
//   };
//   const resetForm = () => {
//     setDate('');
//     setServiceType('oldAgeHome');
//     setDemographic({
//       name: '',
//       age: '',
//       gender: '',
//       address: '',
//       education: '',
//       maritalStatus: '',
//       area: '',
//       socioEconomicStatus: '',
//       systemicIllness: '',
//       associatedProblems: [],
//       underMedication: false,
//       habits: { type: '', frequency: '' },
//       selfReport: {
//         hearingDifficulties: '',
//         speechPerception: '',
//         tinnitus: '',
//         vertigo: '',
//         noiseExposure: '',
//         earPain: '',
//         earDischarge: ''
//       },
//       hearingAidUsed: false,
//       hearingAidEar: '',
//       hearingAidDuration: '',
//       hearingAidPattern: '',
//       hearingAidHours: ''
//     });
//     setQuestionnaire({
//       scapA: '',
//       mmse: '',
//       moca: {
//         visospatial: '',
//         naming: '',
//         memory: '',
//         attention: '',
//         language: '',
//         abstraction: '',
//         delayedRecall: '',
//         orientation: '',
//         total: ''
//       },
//       mocaInterpretation: ''
//     });
//     setOtoscopy({
//       ear: 'right',
//       right: { result: '', notes: '' },
//       left: { result: '', notes: '' }
//     });
//     setTympanometry({
//       ear: 'right',
//       right: '',
//       left: ''
//     });
//     setHearingTest({
//       ear: 'right',
//       mode: 'Ac',
//       thresholds: Array(10).fill('')
//     });
//     setDiagnosis({
//       right: '',
//       left: '',
//       medical: ''
//     });
//     setRecommendations({
//       audiological: false,
//       psychological: false,
//       medical: false,
//       HAT: false,
//       SpeechEvaluation: false
//     });
//     setHearingAid({
//       ear: 'Right',
//       condition: 'Unaided',
//       stimuli: 'Questions',
//       questions: '',
//       words: ''
//     });
//   };
//   return (
//     <Paper elevation={3} sx={{ p: 4, maxWidth: 1100, margin: 'auto', mt: 4, mb: 6 }}>

//       <Box sx={{ position: 'absolute', top: 220, right: 290 }}>
//         <Button
//           variant="contained"
//           color="secondary"
//           startIcon={<DownloadIcon />}
//           onClick={handleDownloadClick}
//           disabled={loading}
//           sx={{
//             borderRadius: 2,
//             boxShadow: 2,
//             '&:hover': {
//               boxShadow: 4,
//               transform: 'translateY(-2px)',
//               transition: 'all 0.3s ease'
//             }
//           }}
//         >
//           Download
//         </Button>
//       </Box>
//       {/* Header */}
//       <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
//         Outreach Evaluation
//       </Typography>

//       <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             name="dateOfAssessment"
//             label="Date of Assessment"
//             type="date"
//             value={date}
//             onChange={(e) => setDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
//       </Box>
//       {/* Service Type */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Service Type
//         </Typography>
//         <RadioGroup row value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
//           <FormControlLabel value="oldAgeHome" control={<Radio color="primary" />} label="Old Age Home" />
//           <FormControlLabel value="camp" control={<Radio color="primary" />} label="Camp" sx={{ ml: 3 }} />

//         </RadioGroup>
//       </Paper>

//       {/* Demographic Information */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Demographic Information
//         </Typography>

//         <Grid container spacing={3}>
//           {/* Left Column */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Name"
//               value={demographic.name}
//               onChange={(e) => setDemographic({ ...demographic, name: e.target.value })}
//               variant="outlined"
//               size="small"
//               sx={{ mb: 2 }}
//             />

//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <TextField
//                   fullWidth
//                   label="Age"
//                   type="number"
//                   value={demographic.age}
//                   onChange={(e) => setDemographic({ ...demographic, age: e.target.value })}
//                   variant="outlined"
//                   size="small"
//                 />
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="gender-label" shrink={true}>Gender</InputLabel>
//                   <Select
//                     labelId="gender-label"
//                     value={demographic.gender}
//                     onChange={(e) => setDemographic({ ...demographic, gender: e.target.value })}
//                     label="Gender"
//                     displayEmpty
//                     renderValue={value => value || "Select Gender"}
//                   >
//                     <MenuItem value="male">Male</MenuItem>
//                     <MenuItem value="female">Female</MenuItem>
//                     <MenuItem value="other">Other</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <TextField
//               fullWidth
//               label="Address"
//               value={demographic.address}
//               onChange={(e) => setDemographic({ ...demographic, address: e.target.value })}
//               variant="outlined"
//               size="small"
//               sx={{ mt: 2 }}
//               multiline
//               rows={2}
//             />

//             <FormControl fullWidth size="small" sx={{ mt: 2 }}>
//               <InputLabel id="education-label">Education</InputLabel>
//               <Select
//                 labelId="education-label"
//                 value={demographic.education}
//                 onChange={(e) => setDemographic({ ...demographic, education: e.target.value })}
//                 label="Education"
//               >
//                 <MenuItem value="primary">Primary</MenuItem>
//                 <MenuItem value="higherPrimary">Higher Primary</MenuItem>
//                 <MenuItem value="secondary">Secondary</MenuItem>
//                 <MenuItem value="preUniversity">Pre University</MenuItem>
//                 <MenuItem value="graduate">Graduate</MenuItem>
//                 <MenuItem value="postGraduate">Post Graduate</MenuItem>
//                 <MenuItem value="diploma">Diploma</MenuItem>
//                 <MenuItem value="phd">Ph.D</MenuItem>
//               </Select>
//             </FormControl>

//             <Grid container spacing={2} sx={{ mt: 2 }}>
//               <Grid item xs={6}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="marital-status-label" shrink={true}>Marital Status</InputLabel>
//                   <Select
//                     labelId="marital-status-label"
//                     value={demographic.maritalStatus}
//                     onChange={(e) => setDemographic({ ...demographic, maritalStatus: e.target.value })}
//                     label="Marital Status"
//                     displayEmpty
//                     renderValue={value => value || "Select Marital Status"}
//                   >
//                     <MenuItem value="married">Married</MenuItem>
//                     <MenuItem value="notMarried">Not Married</MenuItem>
//                     <MenuItem value="widower">Widower</MenuItem>
//                     <MenuItem value="widow">Widow</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="area-label" shrink={true}>Area</InputLabel>
//                   <Select
//                     labelId="area-label"
//                     value={demographic.area}
//                     onChange={(e) => setDemographic({ ...demographic, area: e.target.value })}
//                     label="Area"
//                     displayEmpty
//                     renderValue={value => value || "Select Area"}
//                   >
//                     <MenuItem value="rural">Rural</MenuItem>
//                     <MenuItem value="urban">Urban</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </Grid>

//           {/* Right Column */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Phone Number"
//               value={demographic.phoneNumber}
//               onChange={(e) => setDemographic({ ...demographic, phoneNumber: e.target.value })}
//               variant="outlined"
//               size="small"
//               sx={{ mb: 2 }}
//             />

//             <FormControl fullWidth size="small" sx={{ mb: 2 }}>
//               <InputLabel id="socio-class-label">Socio Economic Class</InputLabel>
//               <Select
//                 labelId="socio-class-label"
//                 value={demographic.socioEconomicStatus}
//                 onChange={(e) => setDemographic({ ...demographic, socioEconomicStatus: e.target.value })}
//                 label="Socio Economic Class"
//               >
//                 <MenuItem value="upper">Upper</MenuItem>
//                 <MenuItem value="upperMiddle">Upper Middle</MenuItem>
//                 <MenuItem value="lowerMiddle">Lower Middle</MenuItem>
//                 <MenuItem value="upperLower">Upper Lower</MenuItem>
//                 <MenuItem value="lower">Lower</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl fullWidth size="small" sx={{ mb: 2 }}>
//               <InputLabel id="systemic-illness-label">Systemic Illness</InputLabel>
//               <Select
//                 labelId="systemic-illness-label"
//                 value={demographic.systemicIllness}
//                 onChange={(e) => setDemographic({ ...demographic, systemicIllness: e.target.value })}
//                 label="Systemic Illness"
//               >
//                 {systemicIllnesses.map((illness) => (
//                   <MenuItem key={illness} value={illness}>{illness}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <Box sx={{ mb: 2 }}>
//               <Typography variant="subtitle2" gutterBottom>
//                 Associated Problems:
//               </Typography>
//               <Grid container spacing={1}>
//                 {associatedProblems.map((problem) => (
//                   <Grid item xs={6} sm={4} key={problem}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={demographic.associatedProblems.includes(problem)}
//                           onChange={() => handleAssociatedProblemsChange(problem)}
//                           color="secondary"
//                           size="small"
//                         />
//                       }
//                       label={problem}
//                     />
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={demographic.underMedication}
//                   onChange={(e) => setDemographic({ ...demographic, underMedication: e.target.checked })}
//                   color="secondary"
//                 />
//               }
//               label="Under Medication"
//               sx={{ mb: 2 }}
//             />

//             {/* Habits Section */}
//             <Box sx={{ mb: 2, p: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" gutterBottom>
//                 Habits
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <FormControl fullWidth size="small">
//                     <InputLabel shrink={true}>Habit Type</InputLabel>
//                     <Select
//                       value={demographic.habits.type}
//                       onChange={(e) => handleHabitTypeChange(e.target.value)}
//                       label="Habit Type"
//                       displayEmpty
//                       renderValue={value => value || "Select Habit Type"}
//                     >
//                       <MenuItem value="smoking">Smoking</MenuItem>
//                       <MenuItem value="alcohol">Alcohol</MenuItem>
//                       <MenuItem value="tobacco">Tobacco</MenuItem>
//                       <MenuItem value="none">None</MenuItem>
//                       <MenuItem value="other">Other</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={6}>
//                   {demographic.habits.type && (
//                     <TextField
//                       fullWidth
//                       label="Frequency"
//                       value={demographic.habits.frequency}
//                       onChange={handleHabitFrequencyChange}
//                       variant="outlined"
//                       size="small"
//                     />
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>
//           </Grid>
//         </Grid>

//         {/* Self Report Section */}
//         <Box sx={{ mt: 3, p: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}>
//           <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//             Self Report
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Hearing Difficulties</InputLabel>
//                 <Select
//                   value={demographic.selfReport.hearingDifficulties}
//                   onChange={(e) => handleSelfReportChange('hearingDifficulties', e.target.value)}
//                   label="Hearing Difficulties"
//                   displayEmpty
//                   renderValue={value => value || "Select Hearing Difficulties"}
//                 >
//                   <MenuItem value="none">None</MenuItem>
//                   <MenuItem value="right">Right Ear</MenuItem>
//                   <MenuItem value="left">Left Ear</MenuItem>
//                   <MenuItem value="both">Both Ears</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Speech Perception</InputLabel>
//                 <Select
//                   value={demographic.selfReport.speechPerception}
//                   onChange={(e) => handleSelfReportChange('speechPerception', e.target.value)}
//                   label="Speech Perception"
//                   displayEmpty
//                   renderValue={value => value || "Select Speech Perception"}
//                 >
//                   <MenuItem value="noDifficulty">No Difficulty</MenuItem>
//                   <MenuItem value="someDifficulty">Some Difficulty</MenuItem>
//                   <MenuItem value="significantDifficulty">Significant Difficulty</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Tinnitus</InputLabel>
//                 <Select
//                   value={demographic.selfReport.tinnitus}
//                   onChange={(e) => handleSelfReportChange('tinnitus', e.target.value)}
//                   label="Tinnitus"
//                   displayEmpty
//                   renderValue={value => value || "Select Tinnitus"}
//                 >
//                   <MenuItem value="none">None</MenuItem>
//                   <MenuItem value="right">Right Ear</MenuItem>
//                   <MenuItem value="left">Left Ear</MenuItem>
//                   <MenuItem value="both">Both Ears</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Vertigo</InputLabel>
//                 <Select
//                   value={demographic.selfReport.vertigo}
//                   onChange={(e) => handleSelfReportChange('vertigo', e.target.value)}
//                   label="Vertigo"
//                   displayEmpty
//                   renderValue={value => value || "Select Vertigo"}
//                 >
//                   <MenuItem value="none">None</MenuItem>
//                   <MenuItem value="subjective">Subjective</MenuItem>
//                   <MenuItem value="objective">Objective</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Noise Exposure</InputLabel>
//                 <Select
//                   value={demographic.selfReport.noiseExposure}
//                   onChange={(e) => handleSelfReportChange('noiseExposure', e.target.value)}
//                   label="Noise Exposure"
//                   displayEmpty
//                   renderValue={value => value || "Select Noise Exposure"}
//                 >
//                   <MenuItem value="none">None</MenuItem>
//                   <MenuItem value="occasional">Occasional</MenuItem>
//                   <MenuItem value="frequent">Frequent</MenuItem>
//                   <MenuItem value="constant">Constant</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={6} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Ear Discharge</InputLabel>
//                 <Select
//                   value={demographic.selfReport.earDischarge}
//                   onChange={(e) => handleSelfReportChange('earDischarge', e.target.value)}
//                   label="Ear Discharge"
//                   displayEmpty
//                   renderValue={value => value || "Select Ear Discharge"}
//                 >
//                   <MenuItem value="none">None</MenuItem>
//                   <MenuItem value="right">Right Ear</MenuItem>
//                   <MenuItem value="left">Left Ear</MenuItem>
//                   <MenuItem value="both">Both Ears</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//         </Box>

//         {/* Hearing Aid Section */}
//         <Box sx={{ mt: 3 }}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={demographic.hearingAidUsed}
//                 onChange={(e) => setDemographic({ ...demographic, hearingAidUsed: e.target.checked })}
//                 color="secondary"
//               />
//             }
//             label="Hearing Aid Used"
//           />

//           {demographic.hearingAidUsed && (
//             <Grid container spacing={2} sx={{ mt: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//               <Grid item xs={6} md={3}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Ear</InputLabel>
//                   <Select
//                     value={demographic.hearingAidEar}
//                     onChange={(e) => setDemographic({ ...demographic, hearingAidEar: e.target.value })}
//                     label="Ear"
//                   >
//                     <MenuItem value="right">Right</MenuItem>
//                     <MenuItem value="left">Left</MenuItem>
//                     <MenuItem value="both">Both</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6} md={3}>
//                 <TextField
//                   fullWidth
//                   label="Duration (years)"
//                   value={demographic.hearingAidDuration}
//                   onChange={(e) => setDemographic({ ...demographic, hearingAidDuration: e.target.value })}
//                   variant="outlined"
//                   size="small"
//                   type="number"
//                 />
//               </Grid>
//               <Grid item xs={6} md={3}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Pattern</InputLabel>
//                   <Select
//                     value={demographic.hearingAidPattern}
//                     onChange={(e) => setDemographic({ ...demographic, hearingAidPattern: e.target.value })}
//                     label="Pattern"
//                   >
//                     <MenuItem value="fullTime">Full Time</MenuItem>
//                     <MenuItem value="partTime">Part Time</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6} md={3}>
//                 <TextField
//                   fullWidth
//                   label="Hours/Day"
//                   value={demographic.hearingAidHours}
//                   onChange={(e) => setDemographic({ ...demographic, hearingAidHours: e.target.value })}
//                   variant="outlined"
//                   size="small"
//                   type="number"
//                 />
//               </Grid>
//             </Grid>
//           )}
//         </Box>
//       </Paper>

//       {/* Questionnaire Section */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Questionnaire
//         </Typography>

//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="subtitle1" fontWeight="bold">SCAP-A</Typography>
//             <TextField
//               fullWidth
//               label="Score"
//               value={questionnaire.scapA}
//               onChange={(e) => setQuestionnaire({ ...questionnaire, scapA: e.target.value })}
//               variant="outlined"
//               size="small"
//               helperText="<4 pass, >4 refer"
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Typography variant="subtitle1" fontWeight="bold">MMSE</Typography>
//             <TextField
//               fullWidth
//               label="Score"
//               value={questionnaire.mmse}
//               onChange={(e) => setQuestionnaire({ ...questionnaire, mmse: e.target.value })}
//               variant="outlined"
//               size="small"
//               helperText=">24 pass, <24 refer"
//             />
//           </Grid>



//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>MOCA Sub-scores</Typography>
//             <Grid container spacing={2}>
//               {[
//                 { label: 'Visospatial/Executive', field: 'visospatial' },
//                 { label: 'Naming', field: 'naming' },
//                 { label: 'Memory', field: 'memory' },
//                 { label: 'Attention', field: 'attention' },
//                 { label: 'Language', field: 'language' },
//                 { label: 'Abstraction', field: 'abstraction' },
//                 { label: 'Delayed Recall', field: 'delayedRecall' },
//                 { label: 'Orientation', field: 'orientation' }
//               ].map((item) => (
//                 <Grid item xs={6} sm={4} md={3} key={item.field}>
//                   <TextField
//                     fullWidth
//                     label={item.label}
//                     value={questionnaire.moca[item.field]}
//                     onChange={(e) => handleMocaChange(item.field, e.target.value)}
//                     variant="outlined"
//                     size="small"
//                   />
//                 </Grid>
//               ))}
//             </Grid>
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="subtitle1" fontWeight="bold">MOCA</Typography>
//             <TextField
//               fullWidth
//               label="Total Score"
//               value={questionnaire.moca.total}
//               onChange={(e) => handleMocaChange('total', e.target.value)}
//               variant="outlined"
//               size="small"
//               sx={{ mb: 2 }}
//             />
//             <FormControl fullWidth size="small">
//               <InputLabel>Interpretation</InputLabel>
//               <Select
//                 value={questionnaire.mocaInterpretation}
//                 onChange={(e) => setQuestionnaire({ ...questionnaire, mocaInterpretation: e.target.value })}
//                 label="Interpretation"
//               >
//                 <MenuItem value="normal">Normal Cognition (26-30)</MenuItem>
//                 <MenuItem value="mild">Mild Cognitive Impairment (18-25)</MenuItem>
//                 <MenuItem value="moderate">Moderate Cognitive Impairment (10-17)</MenuItem>
//                 <MenuItem value="severe">Severe Cognitive Impairment (&lt;10)</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Otoscopy */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Otoscopy
//         </Typography>

//         <FormControl fullWidth size="small" sx={{ mb: 3 }}>
//           <InputLabel>Select Ear</InputLabel>
//           <Select
//             value={otoscopy.ear}
//             onChange={(e) => handleOtoscopyResultChange({ ...otoscopy, ear: e.target.value })}
//             label="Select Ear"
//           >
//             <MenuItem value="right">Right Ear</MenuItem>
//             <MenuItem value="left">Left Ear</MenuItem>
//             <MenuItem value="both">Both Ears</MenuItem>
//           </Select>
//         </FormControl>


//       </Paper>

//       {/* Tympanometry */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Tympanometry
//         </Typography>

//         <FormControl component="fieldset" sx={{ mb: 3 }}>
//           <FormLabel component="legend">Select Ear</FormLabel>
//           <RadioGroup
//             row
//             value={tympanometry.ear}
//             onChange={(e) => setTympanometry({ ...tympanometry, ear: e.target.value })}
//           >
//             <FormControlLabel value="right" control={<Radio color="primary" />} label="Right" />
//             <FormControlLabel value="left" control={<Radio color="primary" />} label="Left" sx={{ ml: 2 }} />
//             <FormControlLabel value="both" control={<Radio color="primary" />} label="Both" sx={{ ml: 2 }} />
//           </RadioGroup>
//         </FormControl>

//         <Grid container spacing={3}>
//           {(tympanometry.ear === 'right' || tympanometry.ear === 'both') && (
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Right Ear Result</InputLabel>
//                 <Select
//                   value={tympanometry.right}
//                   onChange={(e) => setTympanometry({ ...tympanometry, right: e.target.value })}
//                   label="Right Ear Result"
//                   displayEmpty
//                   renderValue={value => value || "Select Right Ear Result"}
//                 >
//                   <MenuItem value="A">A (Normal)</MenuItem>
//                   <MenuItem value="As">As (Sclerosis)</MenuItem>
//                   <MenuItem value="Ad">Ad (Atrophy)</MenuItem>
//                   <MenuItem value="B">B (Perforation)</MenuItem>
//                   <MenuItem value="C">C (Retraction)</MenuItem>
//                   <MenuItem value="Cs">Cs (Retraction with Sclerosis)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           )}

//           {(tympanometry.ear === 'left' || tympanometry.ear === 'both') && (
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth size="small">
//                 <InputLabel shrink={true}>Left Ear Result</InputLabel>
//                 <Select
//                   value={tympanometry.left}
//                   onChange={(e) => setTympanometry({ ...tympanometry, left: e.target.value })}
//                   label="Left Ear Result"
//                   displayEmpty
//                   renderValue={value => value || "Select Left Ear Result"}
//                 >
//                   <MenuItem value="A">A (Normal)</MenuItem>
//                   <MenuItem value="As">As (Sclerosis)</MenuItem>
//                   <MenuItem value="Ad">Ad (Atrophy)</MenuItem>
//                   <MenuItem value="B">B (Perforation)</MenuItem>
//                   <MenuItem value="C">C (Retraction)</MenuItem>
//                   <MenuItem value="Cs">Cs (Retraction with Sclerosis)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           )}
//         </Grid>
//       </Paper>

//       {/* Hearing Test */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Hearing Test
//         </Typography>

//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Select Ear</InputLabel>
//               <Select
//                 value={hearingTest.ear}
//                 onChange={(e) => setHearingTest({ ...hearingTest, ear: e.target.value })}
//                 label="Select Ear"
//               >
//                 <MenuItem value="right">Right Ear</MenuItem>
//                 <MenuItem value="left">Left Ear</MenuItem>
//                 <MenuItem value="both">Both Ears</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Test Mode</InputLabel>
//               <Select
//                 value={hearingTest.mode}
//                 onChange={(e) => setHearingTest({ ...hearingTest, mode: e.target.value })}
//                 label="Test Mode"
//               >
//                 <MenuItem value="Ac">Air Conduction (AC)</MenuItem>
//                 <MenuItem value="Bc">Bone Conduction (BC)</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>

//         <Box sx={{ overflowX: 'auto' }}>
//           <Typography variant="subtitle1" fontWeight="bold" textAlign="center" gutterBottom>
//             Threshold Testing (dB HL)
//           </Typography>
//           <Table size="small" sx={{ minWidth: 650 }}>
//             <TableHead>
//               <TableRow>
//                 <TableCell align="center" sx={{ fontWeight: 'bold' }}>Frequency (Hz)</TableCell>
//                 {frequencies.map(freq => (
//                   <TableCell key={freq} align="center" sx={{ fontWeight: 'bold' }}>{freq}</TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               <TableRow>
//                 <TableCell align="center" sx={{ fontWeight: 'bold' }}>Threshold</TableCell>
//                 {hearingTest.thresholds.map((threshold, index) => (
//                   <TableCell key={index} align="center">
//                     <TextField
//                       size="small"
//                       type="number"
//                       value={threshold}
//                       onChange={(e) => handleThresholdChange(index, e.target.value)}
//                       inputProps={{
//                         min: -10,
//                         max: 120,
//                         style: { textAlign: 'center', width: '60px' }
//                       }}
//                     />
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableBody>
//           </Table>
//         </Box>
//       </Paper>

//       {/* Diagnosis */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Provisional Diagnosis
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Right Ear Diagnosis"
//               size="small"
//               value={diagnosis.right}
//               onChange={(e) => setDiagnosis({ ...diagnosis, right: e.target.value })}
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Left Ear Diagnosis"
//               size="small"
//               value={diagnosis.left}
//               onChange={(e) => setDiagnosis({ ...diagnosis, left: e.target.value })}
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Medical Evaluation Notes"
//               size="small"
//               value={diagnosis.medical}
//               onChange={(e) => setDiagnosis({ ...diagnosis, medical: e.target.value })}
//               variant="outlined"
//               multiline
//               rows={3}
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Recommendations */}
//       <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//           Recommendations
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={6} md={3}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={recommendations.audiological}
//                   onChange={() => setRecommendations({ ...recommendations, audiological: !recommendations.audiological })}
//                   color="primary"
//                 />
//               }
//               label="Audiological Evaluation"
//             />
//           </Grid>
//           <Grid item xs={6} md={3}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={recommendations.psychological}
//                   onChange={() => setRecommendations({ ...recommendations, psychological: !recommendations.psychological })}
//                   color="primary"
//                 />
//               }
//               label="Psychological Evaluation"
//             />
//           </Grid>
//           <Grid item xs={6} md={3}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={recommendations.medical}
//                   onChange={() => setRecommendations({ ...recommendations, medical: !recommendations.medical })}
//                   color="primary"
//                 />
//               }
//               label="Medical Evaluation"
//             />
//           </Grid>
//           <Grid item xs={6} md={3}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={recommendations.HAT}
//                   onChange={() => setRecommendations({ ...recommendations, HAT: !recommendations.HAT })}
//                   color="primary"
//                 />
//               }
//               label="Hearing Aid Trial"
//             />
//           </Grid>
//           <Grid item xs={6} md={3}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={recommendations.speech}
//                   onChange={() => setRecommendations({ ...recommendations, speech: !recommendations.speech })}
//                   color="primary"
//                 />
//               }
//               label="Speech Evaluation"
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Hearing Aid Trial */}
//       {recommendations.HAT && (
//         <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
//           <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
//             Hearing Aid Trial
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Ear</InputLabel>
//                 <Select
//                   value={hearingAid.ear}
//                   onChange={(e) => setHearingAid({ ...hearingAid, ear: e.target.value })}
//                   label="Ear"
//                 >
//                   <MenuItem value="Right">Right</MenuItem>
//                   <MenuItem value="Left">Left</MenuItem>
//                   <MenuItem value="Both">Both</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Condition</InputLabel>
//                 <Select
//                   value={hearingAid.condition}
//                   onChange={(e) => setHearingAid({ ...hearingAid, condition: e.target.value })}
//                   label="Condition"
//                 >
//                   <MenuItem value="Unaided">Unaided</MenuItem>
//                   <MenuItem value="Aided">Aided</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Stimuli</InputLabel>
//                 <Select
//                   value={hearingAid.stimuli}
//                   onChange={(e) => setHearingAid({ ...hearingAid, stimuli: e.target.value })}
//                   label="Stimuli"
//                 >
//                   <MenuItem value="Questions">Questions (max 5)</MenuItem>
//                   <MenuItem value="Words">Words (max 20)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               {hearingAid.stimuli === 'Questions' ? (
//                 <TextField
//                   fullWidth
//                   label="Questions Correct"
//                   size="small"
//                   type="number"
//                   value={hearingAid.questions}
//                   onChange={(e) => setHearingAid({ ...hearingAid, questions: e.target.value })}
//                   inputProps={{ min: 0, max: 5 }}
//                   variant="outlined"
//                 />
//               ) : (
//                 <TextField
//                   fullWidth
//                   label="Words Correct"
//                   size="small"
//                   type="number"
//                   value={hearingAid.words}
//                   onChange={(e) => setHearingAid({ ...hearingAid, words: e.target.value })}
//                   inputProps={{ min: 0, max: 20 }}
//                   variant="outlined"
//                 />
//               )}
//             </Grid>
//           </Grid>
//         </Paper>
//       )}
//       <Dialog
//         open={openPasswordModal}
//         onClose={handlePasswordModalClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           Download Data
//           <IconButton
//             aria-label="close"
//             onClick={handlePasswordModalClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2, mb: 2 }}>
//             <TextField
//               fullWidth
//               label="Password"
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               variant="outlined"
//               sx={{ mb: 3 }}
//             />
//             <FormControl fullWidth>
//               <InputLabel>Format</InputLabel>
//               <Select
//                 value={downloadFormat}
//                 onChange={(e) => setDownloadFormat(e.target.value)}
//                 label="Format"
//               >
//                 <MenuItem value="excel">Excel</MenuItem>
//                 <MenuItem value="pdf">PDF</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handlePasswordModalClose} color="inherit">
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDownloadConfirm}
//             variant="contained"
//             color="primary"
//             disabled={!password}
//           >
//             Download
//           </Button>
//         </DialogActions>
//       </Dialog>
//       {/* Submit Button */}
//       <Box display="flex" justifyContent="center" mt={4}>
//         <Button
//           variant="contained"
//           color="primary"
//           size="large"
//           sx={{
//             px: 6,
//             py: 1.5,
//             fontSize: '1rem',
//             fontWeight: 'bold',
//             minWidth: 200
//           }}
//           onClick={handleSubmit}
//         >
//           Save OutReach
//         </Button>
//       </Box>
//     </Paper>
//   );
// };

// export default OutReach;   


import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Paper,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  RadioGroup,
  Radio,
  FormLabel,
  TableContainer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const OutReach = () => {
  const [date, setDate] = useState('');
  const [serviceType, setServiceType] = useState('oldAgeHome');
  const [loading, setLoading] = useState(false);

  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');
  const [saveStatus, setSaveStatus] = useState({ open: false, message: '', severity: 'success' });

  const [demographic, setDemographic] = useState({
    name: '',
    age: '',
    gender: '',
    address: '',
    education: '',
    maritalStatus: '',
    area: '',
    socioEconomicStatus: '',
    systemicIllness: '',
    associatedProblems: [],
    underMedication: false,
    habits: { type: '', frequency: '' },
    selfReport: {
      hearingDifficulties: '',
      speechPerception: '',
      tinnitus: '',
      vertigo: '',
      noiseExposure: '',
      earPain: '',
      earDischarge: ''
    },
    hearingAidUsed: false,
    hearingAidEar: '',
    hearingAidDuration: '',
    hearingAidPattern: '',
    hearingAidHours: ''
  });

  const [questionnaire, setQuestionnaire] = useState({
    scapA: '',
    mmse: '',
    moca: {
      visospatial: '',
      naming: '',
      memory: '',
      attention: '',
      language: '',
      abstraction: '',
      delayedRecall: '',
      orientation: '',
      total: ''
    },
    mocaInterpretation: ''
  });

  const [otoscopy, setOtoscopy] = useState({
    ear: 'right', // This controls which text boxes are shown
    right: { result: '', notes: '' },
    left: { result: '', notes: '' }
  });

  const [tympanometry, setTympanometry] = useState({
    ear: 'right',
    right: '',
    left: ''
  });

  // Updated Hearing Test State Structure
  const [hearingTest, setHearingTest] = useState({
    rightAC: Array(10).fill(''),
    rightBC: Array(10).fill(''),
    leftAC: Array(10).fill(''),
    leftBC: Array(10).fill('')
  });

  const [diagnosis, setDiagnosis] = useState({
    right: '',
    left: '',
    medical: ''
  });

  const [recommendations, setRecommendations] = useState({
    audiological: false,
    psychological: false,
    medical: false,
    HAT: false,
    SpeechEvaluation: false
  });

  const [hearingAid, setHearingAid] = useState({
    ear: 'Right',
    condition: 'Unaided',
    stimuli: 'Questions',
    questions: '',
    words: ''
  });

  const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];
  const associatedProblems = [
    'Tinnitus',
    'Ear pain',
    'Ear discharge',
    'Vertigo',
    'Exposure to noise',
    'None'
  ];

  const systemicIllnesses = [
    'Diabetes',
    'Hypertension',
    'Cardiovascular disease',
    'Ischemic heart disease',
    'Vascular dementia',
    'Multiple sclerosis',
    'Stroke',
    'thyroid',
    'Chronic Kidney disease',
    'None'
  ];

  // Updated threshold change handler
  const handleThresholdChange = (testType, index, value) => {
    setHearingTest({
      ...hearingTest,
      [testType]: hearingTest[testType].map((item, i) => i === index ? value : item)
    });
  };

  const handleAssociatedProblemsChange = (problem) => {
    const currentProblems = [...demographic.associatedProblems];
    if (currentProblems.includes(problem)) {
      setDemographic({
        ...demographic,
        associatedProblems: currentProblems.filter(p => p !== problem)
      });
    } else {
      setDemographic({
        ...demographic,
        associatedProblems: [...currentProblems, problem]
      });
    }
  };

  const handleMocaChange = (field, value) => {
    setQuestionnaire({
      ...questionnaire,
      moca: {
        ...questionnaire.moca,
        [field]: value
      }
    });
  };

  const handleHabitTypeChange = (value) => {
    setDemographic({
      ...demographic,
      habits: {
        ...demographic.habits,
        type: value
      }
    });
  };

  const handleHabitFrequencyChange = (e) => {
    setDemographic({
      ...demographic,
      habits: {
        ...demographic.habits,
        frequency: e.target.value
      }
    });
  };

  const handleSelfReportChange = (field, value) => {
    setDemographic({
      ...demographic,
      selfReport: {
        ...demographic.selfReport,
        [field]: value
      }
    });
  };

  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

  const handleDownloadConfirm = async () => {
    const correctKey = "Varun@6361";

    if (password !== correctKey) {
      alert("Incorrect key! Download canceled.");
      setPassword('');
      setOpenPasswordModal(false);
      return;
    }

    setOpenPasswordModal(false);
    setLoading(true);
    setSaveStatus({
      message: `Requesting Outreach Evaluation ${downloadFormat}...`,
      severity: "info",
    });

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            table: "outreach_evaluations",
            formName: "Outreach Evaluation",
            format: downloadFormat,
            key: password
          }),
        }
      );

      if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        setSaveStatus({
          message: `Failed: ${body.message || resp.statusText}`,
          severity: "error",
        });
        return;
      }

      const blob = await resp.blob();
      const disposition = resp.headers.get("content-disposition") || "";

      let filename = `Outreach_Evaluation_${Date.now()}.${downloadFormat === "excel" ? "xlsx" : "pdf"
        }`;

      const match = /filename="?([^"]+)"?/.exec(disposition);
      if (match && match[1]) filename = match[1];

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setSaveStatus({
        message: `Download started: ${filename}`,
        severity: "success",
      });

    } catch (err) {
      console.error("Download error:", err);
      setSaveStatus({
        message: `Error downloading file: ${err.message}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

  // Add this handler function if not already present
  const handleOtoscopyResultChange = (ear, field, value) => {
    setOtoscopy({
      ...otoscopy,
      [ear]: {
        ...otoscopy[ear],
        [field]: value
      }
    });
  };

  const handleSubmit = async () => {
    try {
      const formData = {
        dateOfAssessment: date,
        serviceType,
        demographic,
        questionnaire,
        otoscopy,
        tympanometry,
        hearingTest, // Updated structure
        diagnosis,
        recommendations,
        hearingAid: recommendations.HAT ? hearingAid : null
      };

      console.log('Submitting data:', formData);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/outreach`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        alert('Outreach evaluation saved successfully!');
        resetForm();
      } else {
        const errorData = await response.json();
        alert(`Failed to save: ${errorData.error}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error saving outreach evaluation');
    }
  };

  const resetForm = () => {
    setDate('');
    setServiceType('oldAgeHome');
    setDemographic({
      name: '',
      age: '',
      gender: '',
      address: '',
      education: '',
      maritalStatus: '',
      area: '',
      socioEconomicStatus: '',
      systemicIllness: '',
      associatedProblems: [],
      underMedication: false,
      habits: { type: '', frequency: '' },
      selfReport: {
        hearingDifficulties: '',
        speechPerception: '',
        tinnitus: '',
        vertigo: '',
        noiseExposure: '',
        earPain: '',
        earDischarge: ''
      },
      hearingAidUsed: false,
      hearingAidEar: '',
      hearingAidDuration: '',
      hearingAidPattern: '',
      hearingAidHours: ''
    });
    setQuestionnaire({
      scapA: '',
      mmse: '',
      moca: {
        visospatial: '',
        naming: '',
        memory: '',
        attention: '',
        language: '',
        abstraction: '',
        delayedRecall: '',
        orientation: '',
        total: ''
      },
      mocaInterpretation: ''
    });
    setOtoscopy({
      ear: 'right',
      right: { result: '', notes: '' },
      left: { result: '', notes: '' }
    });
    setTympanometry({
      ear: 'right',
      right: '',
      left: ''
    });
    setHearingTest({
      rightAC: Array(10).fill(''),
      rightBC: Array(10).fill(''),
      leftAC: Array(10).fill(''),
      leftBC: Array(10).fill('')
    });
    setDiagnosis({
      right: '',
      left: '',
      medical: ''
    });
    setRecommendations({
      audiological: false,
      psychological: false,
      medical: false,
      HAT: false,
      SpeechEvaluation: false
    });
    setHearingAid({
      ear: 'Right',
      condition: 'Unaided',
      stimuli: 'Questions',
      questions: '',
      words: ''
    });
  };

  // Function to render hearing test table
  const renderHearingTestTable = () => {
    return (
      <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell
                align="center"
                rowSpan={2}
                sx={{
                  fontWeight: 'bold',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                Frequency (Hz)
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#e8f4fd',
                  borderRight: '2px solid #1976d2'
                }}
              >
                Right Ear
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#fde8e8'
                }}
              >
                Left Ear
              </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#e8f4fd',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                AC
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#e8f4fd',
                  borderRight: '2px solid #1976d2'
                }}
              >
                BC
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#fde8e8',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                AC
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#fde8e8'
                }}
              >
                BC
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {frequencies.map((frequency, index) => (
              <TableRow key={frequency}>
                <TableCell align="center" sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                  {frequency}
                </TableCell>
                {/* Right AC */}
                <TableCell align="center" sx={{ borderRight: '1px solid #e0e0e0' }}>
                  <TextField
                    size="small"
                    type="number"
                    value={hearingTest.rightAC[index]}
                    onChange={(e) => handleThresholdChange('rightAC', index, e.target.value)}
                    inputProps={{
                      min: -10,
                      max: 120,
                      step: 5,
                      style: {
                        textAlign: 'center',
                        width: '70px',
                        backgroundColor: '#e8f4fd'
                      }
                    }}
                    variant="outlined"
                  />
                </TableCell>
                {/* Right BC */}
                <TableCell align="center" sx={{ borderRight: '2px solid #1976d2' }}>
                  <TextField
                    size="small"
                    type="number"
                    value={hearingTest.rightBC[index]}
                    onChange={(e) => handleThresholdChange('rightBC', index, e.target.value)}
                    inputProps={{
                      min: -10,
                      max: 120,
                      step: 5,
                      style: {
                        textAlign: 'center',
                        width: '70px',
                        backgroundColor: '#e8f4fd'
                      }
                    }}
                    variant="outlined"
                  />
                </TableCell>
                {/* Left AC */}
                <TableCell align="center" sx={{ borderRight: '1px solid #e0e0e0' }}>
                  <TextField
                    size="small"
                    type="number"
                    value={hearingTest.leftAC[index]}
                    onChange={(e) => handleThresholdChange('leftAC', index, e.target.value)}
                    inputProps={{
                      min: -10,
                      max: 120,
                      step: 5,
                      style: {
                        textAlign: 'center',
                        width: '70px',
                        backgroundColor: '#fde8e8'
                      }
                    }}
                    variant="outlined"
                  />
                </TableCell>
                {/* Left BC */}
                <TableCell align="center">
                  <TextField
                    size="small"
                    type="number"
                    value={hearingTest.leftBC[index]}
                    onChange={(e) => handleThresholdChange('leftBC', index, e.target.value)}
                    inputProps={{
                      min: -10,
                      max: 120,
                      step: 5,
                      style: {
                        textAlign: 'center',
                        width: '70px',
                        backgroundColor: '#fde8e8'
                      }
                    }}
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 1100, margin: 'auto', mt: 4, mb: 6 }}>
      <Box sx={{ position: 'absolute', top: 220, right: 290 }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadClick}
          disabled={loading}
          sx={{
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.3s ease'
            }
          }}
        >
          Download
        </Button>
      </Box>

      <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
        Outreach Evaluation
      </Typography>

      <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            name="dateOfAssessment"
            label="Date of Assessment"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Box>

      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Service Type
        </Typography>
        <RadioGroup row value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
          <FormControlLabel value="oldAgeHome" control={<Radio color="primary" />} label="Old Age Home" />
          <FormControlLabel value="camp" control={<Radio color="primary" />} label="Camp" sx={{ ml: 3 }} />
        </RadioGroup>
      </Paper>

      {/* Demographic Information (Keep as is) */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Demographic Information
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Name"
              value={demographic.name}
              onChange={(e) => setDemographic({ ...demographic, name: e.target.value })}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Age"
                  type="number"
                  value={demographic.age}
                  onChange={(e) => setDemographic({ ...demographic, age: e.target.value })}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="gender-label" shrink={true}>Gender</InputLabel>
                  <Select
                    labelId="gender-label"
                    value={demographic.gender}
                    onChange={(e) => setDemographic({ ...demographic, gender: e.target.value })}
                    label="Gender"
                    displayEmpty
                    renderValue={value => value || "Select Gender"}
                  >
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <TextField
              fullWidth
              label="Address"
              value={demographic.address}
              onChange={(e) => setDemographic({ ...demographic, address: e.target.value })}
              variant="outlined"
              size="small"
              sx={{ mt: 2 }}
              multiline
              rows={2}
            />
            <FormControl fullWidth size="small" sx={{ mt: 2 }}>
              <InputLabel id="education-label">Education</InputLabel>
              <Select
                labelId="education-label"
                value={demographic.education}
                onChange={(e) => setDemographic({ ...demographic, education: e.target.value })}
                label="Education"
              >
                <MenuItem value="primary">Primary</MenuItem>
                <MenuItem value="higherPrimary">Higher Primary</MenuItem>
                <MenuItem value="secondary">Secondary</MenuItem>
                <MenuItem value="preUniversity">Pre University</MenuItem>
                <MenuItem value="graduate">Graduate</MenuItem>
                <MenuItem value="postGraduate">Post Graduate</MenuItem>
                <MenuItem value="diploma">Diploma</MenuItem>
                <MenuItem value="phd">Ph.D</MenuItem>
              </Select>
            </FormControl>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="marital-status-label" shrink={true}>Marital Status</InputLabel>
                  <Select
                    labelId="marital-status-label"
                    value={demographic.maritalStatus}
                    onChange={(e) => setDemographic({ ...demographic, maritalStatus: e.target.value })}
                    label="Marital Status"
                    displayEmpty
                    renderValue={value => value || "Select Marital Status"}
                  >
                    <MenuItem value="married">Married</MenuItem>
                    <MenuItem value="notMarried">Not Married</MenuItem>
                    <MenuItem value="widower">Widower</MenuItem>
                    <MenuItem value="widow">Widow</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="area-label" shrink={true}>Area</InputLabel>
                  <Select
                    labelId="area-label"
                    value={demographic.area}
                    onChange={(e) => setDemographic({ ...demographic, area: e.target.value })}
                    label="Area"
                    displayEmpty
                    renderValue={value => value || "Select Area"}
                  >
                    <MenuItem value="rural">Rural</MenuItem>
                    <MenuItem value="urban">Urban</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Phone Number"
              value={demographic.phoneNumber}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // only numbers

                if (value.length <= 10) {
                  setDemographic({
                    ...demographic,
                    phoneNumber: value
                  });
                }
              }}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
                pattern: "[0-9]*"
              }}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel id="socio-class-label">Socio Economic Class</InputLabel>
              <Select
                labelId="socio-class-label"
                value={demographic.socioEconomicStatus}
                onChange={(e) => setDemographic({ ...demographic, socioEconomicStatus: e.target.value })}
                label="Socio Economic Class"
              >
                <MenuItem value="upper">Upper</MenuItem>
                <MenuItem value="upperMiddle">Upper Middle</MenuItem>
                <MenuItem value="lowerMiddle">Lower Middle</MenuItem>
                <MenuItem value="upperLower">Upper Lower</MenuItem>
                <MenuItem value="lower">Lower</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel id="systemic-illness-label">Systemic Illness</InputLabel>
              <Select
                labelId="systemic-illness-label"
                value={demographic.systemicIllness}
                onChange={(e) => setDemographic({ ...demographic, systemicIllness: e.target.value })}
                label="Systemic Illness"
              >
                {systemicIllnesses.map((illness) => (
                  <MenuItem key={illness} value={illness}>{illness}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Associated Problems:
              </Typography>
              <Grid container spacing={1}>
                {associatedProblems.map((problem) => (
                  <Grid item xs={6} sm={4} key={problem}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={demographic.associatedProblems.includes(problem)}
                          onChange={() => handleAssociatedProblemsChange(problem)}
                          color="secondary"
                          size="small"
                        />
                      }
                      label={problem}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={demographic.underMedication}
                  onChange={(e) => setDemographic({ ...demographic, underMedication: e.target.checked })}
                  color="secondary"
                />
              }
              label="Under Medication"
              sx={{ mb: 2 }}
            />
            <Box sx={{ mb: 2, p: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}>
              <Typography variant="subtitle2" gutterBottom>
                Habits
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel shrink={true}>Habit Type</InputLabel>
                    <Select
                      value={demographic.habits.type}
                      onChange={(e) => handleHabitTypeChange(e.target.value)}
                      label="Habit Type"
                      displayEmpty
                      renderValue={value => value || "Select Habit Type"}
                    >
                      <MenuItem value="smoking">Smoking</MenuItem>
                      <MenuItem value="alcohol">Alcohol</MenuItem>
                      <MenuItem value="tobacco">Tobacco</MenuItem>
                      <MenuItem value="none">None</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  {demographic.habits.type && (
                    <TextField
                      fullWidth
                      label="Frequency"
                      value={demographic.habits.frequency}
                      onChange={handleHabitFrequencyChange}
                      variant="outlined"
                      size="small"
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, p: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            Self Report
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Hearing Difficulties</InputLabel>
                <Select
                  value={demographic.selfReport.hearingDifficulties}
                  onChange={(e) => handleSelfReportChange('hearingDifficulties', e.target.value)}
                  label="Hearing Difficulties"
                  displayEmpty
                  renderValue={value => value || "Select Hearing Difficulties"}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="right">Right Ear</MenuItem>
                  <MenuItem value="left">Left Ear</MenuItem>
                  <MenuItem value="both">Both Ears</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Speech Perception</InputLabel>
                <Select
                  value={demographic.selfReport.speechPerception}
                  onChange={(e) => handleSelfReportChange('speechPerception', e.target.value)}
                  label="Speech Perception"
                  displayEmpty
                  renderValue={value => value || "Select Speech Perception"}
                >
                  <MenuItem value="noDifficulty">No Difficulty</MenuItem>
                  <MenuItem value="someDifficulty">Some Difficulty</MenuItem>
                  <MenuItem value="significantDifficulty">Significant Difficulty</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Tinnitus</InputLabel>
                <Select
                  value={demographic.selfReport.tinnitus}
                  onChange={(e) => handleSelfReportChange('tinnitus', e.target.value)}
                  label="Tinnitus"
                  displayEmpty
                  renderValue={value => value || "Select Tinnitus"}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="right">Right Ear</MenuItem>
                  <MenuItem value="left">Left Ear</MenuItem>
                  <MenuItem value="both">Both Ears</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Vertigo</InputLabel>
                <Select
                  value={demographic.selfReport.vertigo}
                  onChange={(e) => handleSelfReportChange('vertigo', e.target.value)}
                  label="Vertigo"
                  displayEmpty
                  renderValue={value => value || "Select Vertigo"}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="subjective">Subjective</MenuItem>
                  <MenuItem value="objective">Objective</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Noise Exposure</InputLabel>
                <Select
                  value={demographic.selfReport.noiseExposure}
                  onChange={(e) => handleSelfReportChange('noiseExposure', e.target.value)}
                  label="Noise Exposure"
                  displayEmpty
                  renderValue={value => value || "Select Noise Exposure"}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="occasional">Occasional</MenuItem>
                  <MenuItem value="frequent">Frequent</MenuItem>
                  <MenuItem value="constant">Constant</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Ear Discharge</InputLabel>
                <Select
                  value={demographic.selfReport.earDischarge}
                  onChange={(e) => handleSelfReportChange('earDischarge', e.target.value)}
                  label="Ear Discharge"
                  displayEmpty
                  renderValue={value => value || "Select Ear Discharge"}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="right">Right Ear</MenuItem>
                  <MenuItem value="left">Left Ear</MenuItem>
                  <MenuItem value="both">Both Ears</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={demographic.hearingAidUsed}
                onChange={(e) => setDemographic({ ...demographic, hearingAidUsed: e.target.checked })}
                color="secondary"
              />
            }
            label="Hearing Aid Used"
          />
          {demographic.hearingAidUsed && (
            <Grid container spacing={2} sx={{ mt: 1, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Grid item xs={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Ear</InputLabel>
                  <Select
                    value={demographic.hearingAidEar}
                    onChange={(e) => setDemographic({ ...demographic, hearingAidEar: e.target.value })}
                    label="Ear"
                  >
                    <MenuItem value="right">Right</MenuItem>
                    <MenuItem value="left">Left</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  fullWidth
                  label="Duration (years)"
                  value={demographic.hearingAidDuration}
                  onChange={(e) => setDemographic({ ...demographic, hearingAidDuration: e.target.value })}
                  variant="outlined"
                  size="small"
                  type="number"
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Pattern</InputLabel>
                  <Select
                    value={demographic.hearingAidPattern}
                    onChange={(e) => setDemographic({ ...demographic, hearingAidPattern: e.target.value })}
                    label="Pattern"
                  >
                    <MenuItem value="fullTime">Full Time</MenuItem>
                    <MenuItem value="partTime">Part Time</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  fullWidth
                  label="Hours/Day"
                  value={demographic.hearingAidHours}
                  onChange={(e) => setDemographic({ ...demographic, hearingAidHours: e.target.value })}
                  variant="outlined"
                  size="small"
                  type="number"
                />
              </Grid>
            </Grid>
          )}
        </Box>
      </Paper>

      {/* Questionnaire Section (Keep as is) */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Questionnaire
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">SCAP-A</Typography>
            <TextField
              fullWidth
              label="Score"
              value={questionnaire.scapA}
              onChange={(e) => setQuestionnaire({ ...questionnaire, scapA: e.target.value })}
              variant="outlined"
              size="small"
              helperText="<4 pass, >4 refer"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">MMSE</Typography>
            <TextField
              fullWidth
              label="Score"
              value={questionnaire.mmse}
              onChange={(e) => setQuestionnaire({ ...questionnaire, mmse: e.target.value })}
              variant="outlined"
              size="small"
              helperText=">24 pass, <24 refer"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>MOCA Sub-scores</Typography>
            <Grid container spacing={2}>
              {[
                { label: 'Visospatial/Executive', field: 'visospatial' },
                { label: 'Naming', field: 'naming' },
                { label: 'Memory', field: 'memory' },
                { label: 'Attention', field: 'attention' },
                { label: 'Language', field: 'language' },
                { label: 'Abstraction', field: 'abstraction' },
                { label: 'Delayed Recall', field: 'delayedRecall' },
                { label: 'Orientation', field: 'orientation' }
              ].map((item) => (
                <Grid item xs={6} sm={4} md={3} key={item.field}>
                  <TextField
                    fullWidth
                    label={item.label}
                    value={questionnaire.moca[item.field]}
                    onChange={(e) => handleMocaChange(item.field, e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">MOCA</Typography>
            <TextField
              fullWidth
              label="Total Score"
              value={questionnaire.moca.total}
              onChange={(e) => handleMocaChange('total', e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
            />
            <FormControl fullWidth size="small">
              <InputLabel>Interpretation</InputLabel>
              <Select
                value={questionnaire.mocaInterpretation}
                onChange={(e) => setQuestionnaire({ ...questionnaire, mocaInterpretation: e.target.value })}
                label="Interpretation"
              >
                <MenuItem value="normal">Normal Cognition (26-30)</MenuItem>
                <MenuItem value="mild">Mild Cognitive Impairment (18-25)</MenuItem>
                <MenuItem value="moderate">Moderate Cognitive Impairment (10-17)</MenuItem>
                <MenuItem value="severe">Severe Cognitive Impairment (&lt;10)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Otoscopy */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Otoscopy
        </Typography>

        <FormControl fullWidth size="small" sx={{ mb: 3 }}>
          <InputLabel>Select Ear</InputLabel>
          <Select
            value={otoscopy.ear}
            onChange={(e) => setOtoscopy({ ...otoscopy, ear: e.target.value })}
            label="Select Ear"
          >
            <MenuItem value="right">Right Ear</MenuItem>
            <MenuItem value="left">Left Ear</MenuItem>
            <MenuItem value="both">Both Ears</MenuItem>
          </Select>
        </FormControl>

        {/* Right Ear Findings - Show when right or both is selected */}
        {(otoscopy.ear === 'right' || otoscopy.ear === 'both') && (
          <Box sx={{ mb: 3 }}>

            <TextField
              fullWidth
              label="Right Ear Findings"
              value={otoscopy.right.result}
              onChange={(e) => handleOtoscopyResultChange('right', 'result', e.target.value)}
              variant="outlined"
              size="small"
              multiline
              rows={1}
              placeholder="findings"
              sx={{ mb: 2 }}
            />

          </Box>
        )}

        {/* Left Ear Findings - Show when left or both is selected */}
        {(otoscopy.ear === 'left' || otoscopy.ear === 'both') && (
          <Box sx={{ mb: 3 }}>

            <TextField
              fullWidth
              label="Left Ear Findings"
              value={otoscopy.left.result}
              onChange={(e) => handleOtoscopyResultChange('left', 'result', e.target.value)}
              variant="outlined"
              size="small"
              multiline
              rows={1}
              placeholder="findings"
              sx={{ mb: 2 }}
            />

          </Box>
        )}

        {/* Show message when no ear is selected */}
        {otoscopy.ear !== 'right' && otoscopy.ear !== 'left' && otoscopy.ear !== 'both' && (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Please select an ear to enter findings
            </Typography>
          </Box>
        )}
      </Paper>

      {/* Tympanometry (Keep as is) */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Tympanometry
        </Typography>
        <FormControl component="fieldset" sx={{ mb: 3 }}>
          <FormLabel component="legend">Select Ear</FormLabel>
          <RadioGroup
            row
            value={tympanometry.ear}
            onChange={(e) => setTympanometry({ ...tympanometry, ear: e.target.value })}
          >
            <FormControlLabel value="right" control={<Radio color="primary" />} label="Right" />
            <FormControlLabel value="left" control={<Radio color="primary" />} label="Left" sx={{ ml: 2 }} />
            <FormControlLabel value="both" control={<Radio color="primary" />} label="Both" sx={{ ml: 2 }} />
          </RadioGroup>
        </FormControl>
        <Grid container spacing={3}>
          {(tympanometry.ear === 'right' || tympanometry.ear === 'both') && (
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Right Ear Result</InputLabel>
                <Select
                  value={tympanometry.right}
                  onChange={(e) => setTympanometry({ ...tympanometry, right: e.target.value })}
                  label="Right Ear Result"
                  displayEmpty
                  renderValue={value => value || "Select Right Ear Result"}
                >
                  <MenuItem value="A">A (Normal)</MenuItem>
                  <MenuItem value="As">As (Sclerosis)</MenuItem>
                  <MenuItem value="Ad">Ad (Atrophy)</MenuItem>
                  <MenuItem value="B">B (Perforation)</MenuItem>
                  <MenuItem value="C">C (Retraction)</MenuItem>
                  <MenuItem value="Cs">Cs (Retraction with Sclerosis)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {(tympanometry.ear === 'left' || tympanometry.ear === 'both') && (
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel shrink={true}>Left Ear Result</InputLabel>
                <Select
                  value={tympanometry.left}
                  onChange={(e) => setTympanometry({ ...tympanometry, left: e.target.value })}
                  label="Left Ear Result"
                  displayEmpty
                  renderValue={value => value || "Select Left Ear Result"}
                >
                  <MenuItem value="A">A (Normal)</MenuItem>
                  <MenuItem value="As">As (Sclerosis)</MenuItem>
                  <MenuItem value="Ad">Ad (Atrophy)</MenuItem>
                  <MenuItem value="B">B (Perforation)</MenuItem>
                  <MenuItem value="C">C (Retraction)</MenuItem>
                  <MenuItem value="Cs">Cs (Retraction with Sclerosis)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* Updated Hearing Test Section */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Hearing Test (Pure Tone Audiometry)
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Enter threshold values in dB HL for each frequency
        </Typography>
        {renderHearingTestTable()}
      </Paper>

      {/* Diagnosis (Keep as is) */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Provisional Diagnosis
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Right Ear Diagnosis"
              size="small"
              value={diagnosis.right}
              onChange={(e) => setDiagnosis({ ...diagnosis, right: e.target.value })}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Left Ear Diagnosis"
              size="small"
              value={diagnosis.left}
              onChange={(e) => setDiagnosis({ ...diagnosis, left: e.target.value })}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Medical Evaluation Notes"
              size="small"
              value={diagnosis.medical}
              onChange={(e) => setDiagnosis({ ...diagnosis, medical: e.target.value })}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Recommendations (Keep as is) */}
      <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
          Recommendations
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recommendations.audiological}
                  onChange={() => setRecommendations({ ...recommendations, audiological: !recommendations.audiological })}
                  color="primary"
                />
              }
              label="Audiological Evaluation"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recommendations.psychological}
                  onChange={() => setRecommendations({ ...recommendations, psychological: !recommendations.psychological })}
                  color="primary"
                />
              }
              label="Psychological Evaluation"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recommendations.medical}
                  onChange={() => setRecommendations({ ...recommendations, medical: !recommendations.medical })}
                  color="primary"
                />
              }
              label="Medical Evaluation"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recommendations.HAT}
                  onChange={() => setRecommendations({ ...recommendations, HAT: !recommendations.HAT })}
                  color="primary"
                />
              }
              label="Hearing Aid Trial"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recommendations.speech}
                  onChange={() => setRecommendations({ ...recommendations, speech: !recommendations.speech })}
                  color="primary"
                />
              }
              label="Speech Evaluation"
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Hearing Aid Trial (Keep as is) */}
      {recommendations.HAT && (
        <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold" color="secondary">
            Hearing Aid Trial
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Ear</InputLabel>
                <Select
                  value={hearingAid.ear}
                  onChange={(e) => setHearingAid({ ...hearingAid, ear: e.target.value })}
                  label="Ear"
                >
                  <MenuItem value="Right">Right</MenuItem>
                  <MenuItem value="Left">Left</MenuItem>
                  <MenuItem value="Both">Both</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Condition</InputLabel>
                <Select
                  value={hearingAid.condition}
                  onChange={(e) => setHearingAid({ ...hearingAid, condition: e.target.value })}
                  label="Condition"
                >
                  <MenuItem value="Unaided">Unaided</MenuItem>
                  <MenuItem value="Aided">Aided</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Stimuli</InputLabel>
                <Select
                  value={hearingAid.stimuli}
                  onChange={(e) => setHearingAid({ ...hearingAid, stimuli: e.target.value })}
                  label="Stimuli"
                >
                  <MenuItem value="Questions">Questions (max 5)</MenuItem>
                  <MenuItem value="Words">Words (max 20)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              {hearingAid.stimuli === 'Questions' ? (
                <TextField
                  fullWidth
                  label="Questions Correct"
                  size="small"
                  type="number"
                  value={hearingAid.questions}
                  onChange={(e) => setHearingAid({ ...hearingAid, questions: e.target.value })}
                  inputProps={{ min: 0, max: 5 }}
                  variant="outlined"
                />
              ) : (
                <TextField
                  fullWidth
                  label="Words Correct"
                  size="small"
                  type="number"
                  value={hearingAid.words}
                  onChange={(e) => setHearingAid({ ...hearingAid, words: e.target.value })}
                  inputProps={{ min: 0, max: 20 }}
                  variant="outlined"
                />
              )}
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* Download Modal (Keep as is) */}
      <Dialog
        open={openPasswordModal}
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleDownloadConfirm}
            variant="contained"
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>

      {/* Submit Button */}
      <Box display="flex" justifyContent="center" mt={4}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            px: 6,
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            minWidth: 200
          }}
          onClick={handleSubmit}
        >
          Save OutReach
        </Button>
      </Box>
    </Paper>
  );
};

export default OutReach;